import Alpine from 'alpinejs'

export const initIntersectObserver = (): void => {
    Alpine.data('intersectObserver', () => ({
        entered: false,
        enter() {
            this.entered = true
        },
    }))
}
